import { AsyncPipe, NgClass, NgIf, NgOptimizedImage, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { PhoneInputModule } from 'phone-field';
import { BottomSwipeSheetDirective } from '../../../shared/directives/modal-swipe/bottom-swipe-sheet.directive';
import { ModalSwipeDirective } from '../../../shared/directives/modal-swipe/modal-swipe.directive';
import { OverlaySwipeDirective } from '../../../shared/directives/modal-swipe/overlay-swipe.directive';
import { AuthPageAbstract } from '../../common/auth-page.abstract';
import { ChainInputComponent } from 'src/app/shared/components/chain-input/chain-input.component';
import { CardRegisterFormComponent } from './card-register-form/card-register-form.component';
import { DHRegisterFormComponent } from './dh-register-form/dh-register-form.component';
import { LoyaltyProvider } from '../../../api/v1/models/loyalty-provider';

@Component({
  selector: 'app-fresh-auth-page',
  templateUrl: './fresh-auth-page.component.html',
  styleUrls: ['./fresh-auth-page.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    AsyncPipe,
    RouterLink,
    NgClass,
    ReactiveFormsModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    PhoneInputModule,
    ChainInputComponent,
    NgSwitch, NgSwitchCase, NgOptimizedImage,
    ModalSwipeDirective,
    OverlaySwipeDirective,
    BottomSwipeSheetDirective,

    CardRegisterFormComponent,
    DHRegisterFormComponent,
  ]
})
export class FreshAuthPageComponent extends AuthPageAbstract {
  protected readonly LoyaltyProvider = LoyaltyProvider;
}
